import './init';
import './sentry-init';
import { createRoot } from 'react-dom/client';
import './scss/app.scss';
import './js/i18n';
import './js/pdfjs';
import Hubl from './Hubl';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<Hubl />);
